import { ReactNode } from 'react';
import { Inbox } from 'lucide-react';
import { cn } from '@/lib/utils';

interface EmptyStateProps {
  title?: string;
  description?: string;
  icon?: ReactNode;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({
  title = '暂无数据',
  description,
  icon,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center rounded-[6px] border border-dashed border-[#cbd5e1] bg-[#f8fafc] p-10 text-center',
        className
      )}
    >
      <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-[#eef2f6]">
        {icon || <Inbox className="h-6 w-6 text-[#94a3b8]" />}
      </div>
      <p className="text-sm font-medium text-[#061b31]">{title}</p>
      {description && (
        <p className="mt-1 max-w-xs text-xs text-[#64748d]">{description}</p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
